import $ from 'jquery';

// Погрешность вычисляемой высоты (для корректной работы на iPhone)
const HEIGHT_ERROR = 75;

export const getFullHeight = () => window.innerHeight;

export const getDefaultInitialHeight = () => ($(window).height() / 4) * 3;

// 1. Инициализирует плавное закрытие модального окна без скачков
// 2. При включенной опции swipeControl реализует закрытие модального окна в 2 свайпа:
//    - по первому свайпу только прокрутка к началу модального окна,
//    - по второму свайпу - закрытие.
//
// Данная функция поддерживается только для больших модальных окон
export function popupScrollHandler($popup, swipeControl = false) {
  let endHeight;
  let lastHeight;
  /** @type boolean */
  let isBottomReached = false;
  let initialHeight;

  function handleClose($popup) {
    if (
      !window.openingScrolling &&
      !window.closingPopup &&
      '#' + $popup.prop('id') === window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1]
    ) {
      window.closingPopup = true;
      history.back();
      if (window.open_link_photo) $('html, body').animate({ scrollTop: $(window).scrollTop() }, 300);
      if (swipeControl) {
        $popup.find('.fake-overlay').css('display', '');
      }
    }
  }

  function handleTouchEnd() {
    endHeight = $(this).scrollTop();
    isBottomReached = isBottomReached || endHeight > getFullHeight() * 1.5;
    if (isBottomReached && !window.closingPopup) {
      $(this).find('.fake-overlay').css('display', 'none');
    }
  }

  function handleScroll() {
    if (window.closingPopup) return;

    if ($(this).find('.popup-select__body').position()?.top <= 0) {
      $(this).find('.popup-select__header').addClass('popup-select__header-fixed');
      $(this).find('.popup-select__body').addClass('popup-select__body-fixed');
    } else {
      $(this).find('.popup-select__header').removeClass('popup-select__header-fixed');
      $(this).find('.popup-select__body').removeClass('popup-select__body-fixed');
    }

    const currentHeight = $(this).scrollTop();
    const scrollSpeed = Math.abs(lastHeight - currentHeight);
    lastHeight = currentHeight;
    if (!isBottomReached && currentHeight < initialHeight - HEIGHT_ERROR) {
      if (currentHeight === 0 || scrollSpeed <= 5) {
        handleClose($(this));
      }
    } else if ($(this).hasClass('drawer__wrapper') && currentHeight > initialHeight) {
      $(this).scrollTop(initialHeight);
    }
  }

  function handleScrollEnd() {
    if (window.closingPopup) return;

    if (window.openingScrolling) {
      initialHeight = $(this).find('.popup-select__body, .drawer')[0].getBoundingClientRect().height;
      if (initialHeight === 0) {
        initialHeight = getDefaultInitialHeight();
      } else if ($(this).hasClass('popup-select')) {
        initialHeight = Math.min(initialHeight, getDefaultInitialHeight());
      }
    }

    if (swipeControl) {
      setTimeout(() => $(this).css('overflow', ''), 10);
      endHeight = null;
    }

    const currentHeight = $(this).scrollTop();
    if (isBottomReached && currentHeight < HEIGHT_ERROR) {
      isBottomReached = false;
      $(this).find('.fake-overlay').css('display', '');
      $(this).scrollTop($(window).height() + currentHeight);
    }
  }

  return () => {
    if (swipeControl) {
      $popup.on('touchstart', function () {
        endHeight = null;
        $(this).css('overflow', '');
      });

      $popup.on('touchend', handleTouchEnd);
    }

    $popup.off('scroll').on('scroll', handleScroll);

    $popup.off('scrollend').on('scrollend', handleScrollEnd);
  };
}
